<template>
  <div :class="agendamento.style" class="agendamento_ficha__conteudo">
    <input
      id="_id"
      v-model="agendamento._id"
      data-test-id="input-_id"
      type="hidden"
      name="_id"
      class="form-control"
    />
    <Dropdown ref="dropdown" class="dropdown-form" style="width: 100%">
      <button
        id="agendamento-guias"
        data-test-id="button-agendamento-guias"
        type="button"
        class="btn btn-default dropdown-toggle"
        style="width: 100%"
        @click="recuperarVencimentosGuias()"
      >
        {{
          agendamento.guia.length > 0
            ? `
                ${agendamento.guia[0].numero}
                ${
                  agendamento.guia.length > 1
                    ? `, +${agendamento.guia.length - 1} guia(s)`
                    : ''
                }
                `
            : 'Selecione as guias'
        }}
        <span class="caret"></span>
        <span
          v-if="validarPendenciaDeMateriais"
          v-tooltip.bottom="'Existem pendências de materiais nas guias!'"
          class="fa fa-exclamation-circle alerta"
        ></span>
      </button>
      <template #dropdown>
        <li v-if="!agendamento.paciente.nome_social" style="color: #888">
          Selecione um paciente
        </li>
        <li v-for="guia in guiasReduzidas" :key="guia._id">
          <div class="guia-agendamento">
            <span class="guia-numero">
              {{ guia.numero }} - {{ guia.especialidade }}
              <span v-if="guia.vencimento && guia.vencimento.dias">
                , vencimento em
                <span class="guia-vencimento"
                  >{{ guia.vencimento.dias }} dias</span
                >
              </span>
            </span>
            <div
              v-if="verificaAcao('alterar_guia_agendamento')"
              style="display: flex; justify-content: end; min-width: 80px"
            >
              <button
                v-if="existeNoAgendamento(guia._id)"
                v-tooltip="
                  existeDuasVezesNoAgendamento(guia._id)
                    ? 'A guia já foi adicionada outra vez'
                    : 'Adicionar a guia mais uma vez'
                "
                :data-test-id="`button-guia-${guia._id}-adicionar-mais-uma`"
                type="button"
                :disabled="existeDuasVezesNoAgendamento(guia._id)"
                :class="[
                  'btn',
                  existeDuasVezesNoAgendamento(guia._id)
                    ? 'btn-default'
                    : 'btn-primary',
                  'btn-xs',
                  existeDuasVezesNoAgendamento(guia._id) ? 'active' : '',
                ]"
                @click="adicionarGuia(guia)"
              >
                <span class="fa fa-plus"></span> 1
              </button>
              <button
                v-if="existeNoAgendamento(guia._id)"
                :data-test-id="`button-guia-${guia._id}-remover`"
                type="button"
                class="btn btn-danger btn-xs"
                @click="removerGuia(guia._id)"
              >
                Remover
              </button>
              <button
                v-else
                :data-test-id="`button-guia-${guia._id}-adicionar`"
                type="button"
                class="btn btn-success btn-xs"
                @click="adicionarGuia(guia)"
              >
                Adicionar
              </button>
            </div>
          </div>
        </li>
      </template>
    </Dropdown>
    <div
      v-tooltip.left="
        agendamento.paciente.nome_social
          ? agendamento.paciente.riscoDeQueda
            ? 'O paciente possui risco de queda'
            : agendamento.paciente.nome_social
          : 'Clique para selecionar o paciente'
      "
      :class="agendamento.paciente.riscoDeQueda && 'riscoDeQueda'"
    >
      <BuscarSelecionar
        id="agendamento-paciente"
        :lista="pacientes"
        :selecionado="agendamento.paciente"
        :exibir="['nome_social', 'nome', 'docs_pessoais.cpf']"
        :minimo="3"
        @selecionar="selecionarPaciente"
        @limpar="limparPaciente"
        @recuperar="recuperarPacientes"
      />
    </div>
    <div v-tooltip.left="'Convênio'">
      <select
        id="convenios"
        v-model="agendamento.paciente.convenio"
        data-test-id="select-convenios"
        name="convenios"
        class="form-control convenios"
      >
        <option
          v-for="convenio in convenios"
          :key="convenio._id"
          :value="convenio"
        >
          {{ convenio.nome }}
        </option>
      </select>
    </div>
    <div
      v-tooltip.left="
        agendamento.profissional && agendamento.profissional.nome
          ? agendamento.profissional.nome
          : 'Clique para selecionar o profissional'
      "
    >
      <BuscarSelecionar
        id="agendamento-profissional"
        :lista="profissionais"
        :selecionado="agendamento.profissional"
        :exibir="['nome']"
        :minimo="0"
        :ativo="verificaProfissionalAtivo"
        :exibir-chave="false"
        @selecionar="selecionarProfissional"
        @limpar="limparProfissional"
        @recuperar="recuperarProfissionais"
      />

      <div>
        <div
          class="btn-group btn-group-justified"
          role="group"
          aria-label="..."
        >
          <div v-if="agendamento.statusAtual" class="btn-group" role="group">
            <button
              :data-test-id="`button-status-atual-${agendamento.status}`"
              class="btn btn-default btn-sm btn-acoes disabled"
              style="color: #008080; opacity: 1"
              type="button"
            >
              {{ agendamento.statusAtual }}
            </button>
          </div>
          <div
            v-for="status in agendamento.statusAgendamentoSeguintes"
            :key="status.id"
            class="btn-group"
            role="group"
          >
            <button
              :data-test-id="`button-status-${status.id}`"
              class="btn btn-default btn-sm btn-acoes"
              type="button"
              @click="
                enviarParaStatus(
                  agendamento,
                  status,
                  horaAgendamento,
                  data,
                  especialidade,
                  unidade
                )
              "
            >
              {{ status.descricao }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-group btn-group-justified" role="group" aria-label="...">
      <div class="btn-group" role="group">
        <AgendamentoEditar
          v-tooltip.bottom="'Editar'"
          :agendamento="agendamento"
          :hora="horaAgendamento"
          :encaixe="encaixe"
          :horas-disponiveis="horasDisponiveis"
          @atualizarHora="atualizarHora"
          @imprimirEtiqueta="imprimirEtiqueta"
        />
      </div>
      <div
        v-if="
          agendamento._id &&
          (agendamento.paciente._id || agendamento.paciente.id) &&
          !agendamento.encaixe &&
          verificaAcao('protuario_agendamento')
        "
        class="btn-group"
        role="group"
      >
        <RouterLink
          v-tooltip.bottom="'Evolucao'"
          data-test-id="link-evolucao"
          :to="{
            path: `/paciente/${
              agendamento.paciente._id || agendamento.paciente.id
            }/evolucao2`,
            query: {
              agendamento: agendamento._id,
            },
          }"
          role="button"
          class="btn btn-sm btn-default"
        >
          <span class="fa fa-clipboard" />
        </RouterLink>
      </div>
      <div
        v-if="
          agendamento._id &&
          !agendamento.encaixe &&
          verificaAcao('repetir_agendamento')
        "
        class="btn-group"
        role="group"
      >
        <AgendamentoRepetir
          v-tooltip.bottom="'Repetir'"
          :hora="hora"
          :data="data"
          :unidade="unidade"
          :especialidade="especialidade"
          :agendamento="agendamento"
          :agendas="agendas"
          @atualizar="emitirAtualizar()"
        />
      </div>
      <div class="btn-group" role="group">
        <button
          id="botaoLimpar"
          v-tooltip.bottom="'Limpar'"
          data-test-id="button-botao-limpar"
          name="botaoLimpar"
          type="button"
          class="btn btn-sm btn-default"
          @click="deletar(agendamento)"
        >
          <span class="fa fa-trash" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

import BuscarSelecionar from '@/componentes/formulario/BuscarSelecionar'
import STATUS_AGENDAMENTO from '@/constantes/dominio/STATUS_AGENDAMENTO'
import AgendamentoServico from '@/servicos/AgendamentoServico'
import AgendaServico from '@/servicos/AgendaServico'
import ControleAcessoServico from '@/servicos/ControleAcessoServico'
import ConvenioServico from '@/servicos/ConvenioServico'
import GuiaServico from '@/servicos/GuiaServico'
import MensagemServico from '@/servicos/MensagemServico'
import PacienteServico from '@/servicos/PacienteServico'
import ProfissionalServico from '@/servicos/ProfissionalServico'
import { isObjectIdValido } from '@/utils/object-id'

import AgendamentoEditar from './AgendamentoEditar'
import AgendamentoRepetir from './AgendamentoRepetir'

const profissionalServico = new ProfissionalServico()
const pacienteServico = new PacienteServico()
const agendaServico = new AgendaServico()
const agendamentoServico = new AgendamentoServico()
const controleAcessoServico = new ControleAcessoServico()
const guiaServico = new GuiaServico()
const mensagemServico = new MensagemServico()
const convenioServico = new ConvenioServico()

export default {
  name: 'AgendamentoFicha',
  components: {
    AgendamentoEditar,
    AgendamentoRepetir,
    BuscarSelecionar,
  },
  props: {
    agendamento: {
      type: Object,
      required: true,
    },
    agendas: {
      type: Array,
      default: () => {
        return []
      },
    },
    hora: {
      type: String,
      required: false,
      default() {
        return ''
      },
    },
    data: {
      type: String,
      required: true,
    },
    unidade: {
      type: String,
      required: true,
    },
    especialidade: {
      type: String,
      required: true,
    },
    encaixe: {
      type: Boolean,
      required: false,
      default() {
        return false
      },
    },
  },

  data() {
    return {
      guias: [],
      pacientes: [],
      profissionais: [],
      convenios: [],
      horasDisponiveis: [],
      horaAgendamento: this.hora,
    }
  },
  computed: {
    statusAgendamento() {
      return STATUS_AGENDAMENTO.valores
    },
    guiasReduzidas() {
      const { items, dup } = this.guias.reduce(
        (acc, curr) => {
          var { _id, numero, especialidade, vencimento } = curr
          acc.items[_id] = acc.items[_id] ? (acc.items[_id] += 1) : 1

          if (acc.items[curr._id] >= 2) {
            var repeticoes = acc.items[curr._id]
            acc.dup.push({
              _id,
              numero,
              especialidade,
              repeticoes,
              vencimento,
            })
          }

          return acc
        },
        {
          items: {},
          dup: [],
        }
      )

      for (const guiaId in items) {
        var existe = dup.find((g) => g._id === guiaId)
        if (!existe) {
          var { _id, numero, especialidade, vencimento } = this.guias.find(
            (g) => g._id === guiaId
          )
          dup.push({
            _id,
            numero,
            especialidade,
            vencimento,
            repeticoes: 1,
          })
        }
      }

      return dup
    },
    validarPendenciaDeMateriais() {
      if (this.agendamento.guia && this.agendamento.guia.length) {
        return this.agendamento.guia.some((g) => {
          return (
            g.especialidade == 'Ortopedia' &&
            guiaServico.validarPendenciaDeMateriais(g.agendamentosGuias)
          )
        })
      }
      return false
    },
  },
  created() {
    if (this.agendamento.paciente.convenio) {
      this.convenios.push(this.agendamento.paciente.convenio)
    }
  },
  mounted() {
    this.recuperarHorasDisponiveis()

    if (this.agendamento.guia && this.agendamento.guia.length) {
      this.guias.push(...this.agendamento.guia)
      this.agendamento.guia = [...this.guias]
      this.agendamento.guiaAntiga = [...this.agendamento.guia]
    }

    this.recuperarGuiaPaciente(this.agendamento.paciente._id)
  },
  methods: {
    async enviarParaStatus(
      agendamento,
      status,
      hora,
      data,
      especialidade,
      unidade
    ) {
      agendamento.status = status.id

      if (agendamento.status === 'assinado') {
        const result =
          await agendamentoServico.atualizarAgendamentoAssinado(agendamento)

        this.processarResultadoSalvar(result)
      } else if (agendamento.status === 'evoluido') {
        const result =
          await agendamentoServico.atualizarAgendamentoEvoluido(agendamento)
        if (!result.agendamento) {
          mensagemServico.alerta(
            result.erro.content,
            'Erro ao evoluir agendamento'
          )
          return
        }

        this.processarResultadoSalvar(result)
      } else if (agendamento.status === 'faltou-sem-justificativa') {
        const result =
          await agendamentoServico.atualizarAgendamentoFaltouSemJustificativa(
            agendamento
          )

        this.processarResultadoSalvar(result)
      } else {
        this.salvar(agendamento, hora, data, especialidade, unidade)
      }
    },
    existeDuasVezesNoAgendamento(guiaId) {
      var guiasAchada = this.agendamento.guia.filter((g) => g._id === guiaId)

      if (guiasAchada.length >= 2) {
        return true
      } else {
        return false
      }
    },
    existeNoAgendamento(guiaId) {
      var guiaAchada = this.agendamento.guia.find((g) => g._id === guiaId)

      if (guiaAchada) {
        return true
      } else {
        return false
      }
    },
    adicionarGuia(guia) {
      if (this.agendamento._id) {
        agendamentoServico
          .adicionarGuia(this.agendamento._id, guia._id)
          .then((res) => {
            if (!res.erro) {
              var guiaAdicionada = this.guias.find((g) => g._id === guia._id)
              this.agendamento.guia.push(guiaAdicionada)
            }
          })
      } else {
        this.agendamento.guia.push(guia)
      }
    },
    removerGuia(guiaId) {
      if (this.agendamento.guia.length === 1) {
        mensagemServico.alerta('Agendamento deve possuir pelo menos uma guia!')
        return
      }

      var removerGuia = () => {
        var indexOf = this.agendamento.guia.findIndex((g) => g._id === guiaId)

        if (~indexOf) {
          this.agendamento.guia.splice(indexOf, 1)
        }
      }

      if (this.agendamento._id) {
        agendamentoServico
          .removerGuia(this.agendamento._id, guiaId)
          .then((res) => {
            removerGuia()
          })
      } else {
        removerGuia()
      }
    },
    verificaAcao(nome) {
      return controleAcessoServico.verificaAcao(nome)
    },
    emitirAtualizar() {
      this.$emit('atualizar')
    },
    verificaProfissionalAtivo(item) {
      return !item.bloqueado
    },
    atualizarHora(agendamento, horaEncaixe) {
      this.horaAgendamento = horaEncaixe
    },
    imprimirEtiqueta() {
      agendamentoServico.imprimirEtiqueta(this.agendamento).then((res) => {
        const blob = new Blob([res], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)
        window.open(url)
      })
    },
    recuperarHorasDisponiveis() {
      if (this.unidade && this.encaixe) {
        agendaServico
          .recuperarAgendas({
            unidade: this.unidade,
            especialidade: this.especialidade,
          })
          .then((result) => {
            moment.locale('pt-br')
            const diaSemana = moment(this.data).format('dddd').split('-')[0]
            const agendaDia = result.agenda.find(
              (a) => a.horarios.dia_semana === diaSemana
            )

            if (agendaDia) {
              const horas = agendaDia.horarios.horas.reduce((array, hora) => {
                return [...array, hora.hora]
              })

              this.horasDisponiveis = horas
            }
          })
      }
    },
    deletar(agendamento) {
      if (agendamento._id) {
        agendamentoServico.remover(agendamento._id).then((res) => {
          delete agendamento._id
          agendamento.paciente = {
            nome: '',
            telefone: '',
            preAgendamento: false,
            valido: false,
            convenio: {
              nome: '',
              plano: '',
            },
          }
          agendamento.profissional = {}
          agendamento.style = ''
          agendamento.status = ''
          delete agendamento.statusAtual
          agendamento.encaixe = false
          agendamento.statusAgendamentoSeguintes = [
            this.statusAgendamento.find((x) => x.id === 'marcado'),
          ]
          agendamento.repetir = {
            acabarEm: '',
            regra: '',
            repeticoes: [],
          }
          agendamento.original = ''
          agendamento.sequencial = ''
          agendamento.derivados = []
          agendamento.guia = []
          agendamento.observacao = ''
          agendamento.procedimento = {}
        })
      }
    },
    processarResultadoSalvar(result) {
      if (!result || !result.agendamento || !result.agendamento.paciente) {
        console.error('Falha ao salvar agendamento', result)
        return null
      }

      const agendamento = this.processarDepoisDeSalvar(result.agendamento)
      this.$emit('atualizarAgendamento', agendamento)
      return agendamento
    },
    processarDepoisDeSalvar(agendamento) {
      agendamento.paciente.valido = true
      const status = this.statusAgendamento.find(
        (x) => x.id === this.agendamento.status
      )

      if (status) {
        agendamento.style = status.id
        agendamento.statusAtual = status.descricao
        agendamento.statusAgendamentoSeguintes = []

        status.proximo.forEach((key, value) => {
          const s = this.statusAgendamento.find((x) => x.id === key)

          if (this.verificaAcao(s.acao)) {
            agendamento.statusAgendamentoSeguintes.push(s)
          }
        })
      }

      agendamento.paciente.convenio =
        agendamento.paciente.convenio || this.agendamento.paciente.convenio
      agendamento.repetir = { regra: '', repeticoes: [] }
      agendamento.guia = [{ _id: '', numero: '' }]
      return agendamento
    },
    salvar(agendamento, hora, data, especialidade, unidade) {
      agendamento.unidade = unidade
      agendamento.data = moment(data).format('YYYY-MM-DD')
      agendamento.especialidade = especialidade
      agendamento.hora = hora
      let msgErro = ''

      if (!agendamento.status) {
        msgErro = 'Informe o status do agendamento para salvar.'
      }

      if (!agendamento.profissional) {
        msgErro = 'Informe o profissional para salvar.'
      }

      if (!agendamento.paciente.nome) {
        msgErro = 'Informe o nome do paciente para salvar.'
      }

      if (!agendamento.paciente.nome_social) {
        this.agendamento.paciente.nome_social = this.agendamento.paciente.nome
      }

      if (!agendamento.paciente.telefone) {
        msgErro = 'Informe o contato do paciente para salvar.'
      }

      if (
        !agendamento.paciente.valido &&
        !agendamento.paciente.preAgendamento
      ) {
        msgErro = 'Informe o paciente corretamente ou marque como pré-agendado.'
      }

      if (
        (!agendamento.guia || !agendamento.guia.length) &&
        agendamento.status !== 'pre_agendado'
      ) {
        mensagemServico.alerta('Informe a guia para salvar!')
        return
      }

      if (msgErro) {
        mensagemServico.alerta(msgErro)
        return
      }

      if (agendamento.status.descricao) {
        agendamento.status = agendamento.status.descricao
      }

      if (agendamento._id) {
        agendamentoServico
          .atualizar(agendamento._id, agendamento)
          .then((result) => {
            this.processarResultadoSalvar(result)
          })
      } else {
        agendamentoServico.adicionarAgendamento(agendamento).then((result) => {
          this.processarResultadoSalvar(result)
        })
      }
    },
    selecionarPaciente(paciente) {
      this.agendamento.paciente = {
        _id: paciente._id,
        nome: paciente.nome,
        nome_social: paciente.nome_social,
        dataNascimento: paciente.data_nascimento,
        telefone: paciente.contato.telefone
          ? paciente.contato.telefone
          : paciente.contato.celular
            ? paciente.contato.celular
            : '',
        convenio: {},
        riscoDeQueda: paciente.riscoDeQueda || false,
        preAgendamento: false,
        valido: true,
      }

      this.convenios = paciente.convenios
      this.agendamento.paciente.convenio = this.convenios[0]
      this.recuperarGuiaPaciente(paciente._id)
    },
    recuperarGuiaPaciente(pacienteId) {
      if (!isObjectIdValido(pacienteId)) return
      guiaServico.recuperarPorPaciente(pacienteId).then((res) => {
        var guiasDoPaciente = res.guias.map((guia) => {
          return {
            ...guia,
            numero: guia.autorizacao.numeroGuia,
          }
        })

        guiasDoPaciente.forEach((g) => {
          if (!this.agendamento.guia.map((guia) => guia._id).includes(g._id)) {
            this.guias.push(g)
          }
        })
      })
    },
    limparPaciente() {
      this.agendamento.paciente = {}
      this.agendamento.guia = []
      this.guias = []
    },
    selecionarProfissional(profissional) {
      this.agendamento.profissional = {
        _id: profissional._id,
        nome: profissional.nome,
      }

      if (this.agendamento._id) {
        this.$emit('atualizarAgendamento', this.agendamento)
        agendamentoServico
          .atualizar(this.agendamento._id, this.agendamento)
          .then((result) => {
            this.processarResultadoSalvar(result)
          })
      }
    },
    limparProfissional() {
      this.agendamento.profissional = {}
    },
    recuperarPacientes(filtro) {
      const data = {
        nome: filtro.palavra,
        ativo: true,
        skip: (filtro.pagina - 1) * filtro.limite,
        limit: filtro.limite,
        orderBy: filtro.chave,
      }

      pacienteServico.recuperarTodos(data).then((result) => {
        this.pacientes = result.pacientes
      })
    },
    recuperarProfissionais(filtro) {
      const data = {
        nome: filtro.palavra,
        unidade: this.unidade,
        especialidade: this.especialidade,
        hora: this.horaAgendamento,
        data: moment(this.data).format('YYYY-MM-DD'),
        skip: (filtro.pagina - 1) * filtro.limite,
        limit: filtro.limite,
        orderBy: filtro.chave,
      }

      profissionalServico
        .recuperarProfissionaisPorAgendamento(data)
        .then((result) => {
          this.profissionais = result.profissionais

          this.profissionais.forEach((p) => {
            if (p.bloqueado) {
              p.nome = `${p.nome} (${p.motivo})`
            }
          })
        })
    },
    recuperarVencimentosGuias() {
      this.guias.map(async (g, i) => {
        const { guia } = await guiaServico.recuperar(g._id)
        const { convenio } = await convenioServico.recuperar(
          guia.beneficiario.convenio._id
        )

        if (convenio.vencimentoGuiaDias) {
          const diffEmissaoParaHoje = moment
            .duration(moment().diff(guia.autorizacao.dataEmissao))
            .as('days')
          if (diffEmissaoParaHoje < convenio.vencimentoGuiaDias) {
            g.vencimento = { dias: parseInt(diffEmissaoParaHoje) }
            this.$set(this.guias, i, g)
          }
        }
      })
    },
  },
}
</script>

<style>
.agendamento_ficha__conteudo {
  padding: 8px;
  border: 1px solid #ecf0f1;
}

.agendamento_ficha__conteudo .convenios,
.agendamento_ficha__conteudo #status {
  padding: 2px 5px !important;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: none;
  border-bottom: 1px solid #ecf0f1 !important;
  border-radius: 0 !important;
}

.agendamento_ficha__conteudo #status {
  -webkit-appearance: none;
  -moz-appearance: none;
  text-transform: uppercase;
  border: none !important;
}

.agendamento_ficha__conteudo input {
  padding: 2px 8px !important;
  background-color: white !important;
  border: none !important;
  border-bottom: 1px solid #ecf0f1 !important;
  border-radius: 0 !important;
}

.agendamento_ficha__conteudo span.input-group-addon {
  background-color: white !important;
  border: none !important;
  border-bottom: 1px solid #ecf0f1 !important;
  border-radius: 0 !important;
}

.agendamento_ficha__conteudo .btn-acoes {
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: uppercase;
  white-space: nowrap;
}

.agendamento_ficha__conteudo .guia-vencimento {
  color: #e74c3c;
}

.riscoDeQueda {
  display: flex;
  align-items: center;
  justify-items: center;
  background: white;
}

.riscoDeQueda::after {
  margin-top: -4px;
  font-size: 18px;
  font-weight: bold;
  color: tomato;
  content: '⚠';
}

.alerta {
  position: absolute;
  color: tomato;
  font-size: 16px;
  right: 5px;
}
</style>
